"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.91667 21H13.4773V12.9492H16.2424L16.697 9.75H13.4773V7.53516C13.4773 7.04297 13.553 6.65625 13.7803 6.41016C14.0076 6.12891 14.5 5.98828 15.1818 5.98828H17V3.14062C16.3182 3.07031 15.4091 3 14.3485 3C12.9848 3 11.9242 3.38672 11.1288 4.125C10.2955 4.86328 9.91667 5.88281 9.91667 7.21875V9.75H7V12.9492H9.91667V21Z"
  })];
};

exports.default = _default;